export const VAPID_KEY: Readonly<string> =
    "BINxxFt_ke5pxKGQlpHX1qwS4cHC8kQ0oQKBQxopcc5F8EGiIJ2Y0xt7hgMuNoc7oqNPaHBY5B54EG9pXAliTn0";

export const firebaseConfig = {
    apiKey: "AIzaSyAwaWs-G3rbTjwsub2O4O-hmvuLJkYNS0k",
    authDomain: "eduschool-d1f19.firebaseapp.com",
    projectId: "eduschool-d1f19",
    storageBucket: "eduschool-d1f19.firebasestorage.app",
    messagingSenderId: "920552725223",
    appId: "1:920552725223:web:73daf618aaf7cbe1582042",
    measurementId: "G-XT2XXL2FR5"
};
